import {
  ItManagementApplicationDetailsPageQueryDocument,
  ItManagementUpdateSoftwarePaymentDocument,
  ItManagementUpdateSoftwarePaymentMutation,
  ItManagementUpdateSoftwarePaymentMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useUpdateSoftwarePayment = () => {
  const [updateSoftwarePayment, { loading }] = useMutation(
    ItManagementUpdateSoftwarePaymentDocument,
    {
      extractorFn: (data: ItManagementUpdateSoftwarePaymentMutation) =>
        data.itManagementMutations.updateItmanagementSoftwarePayment,
    }
  )

  return {
    update(
      variables: ItManagementUpdateSoftwarePaymentMutationVariables,
      currency: string,
      companyId: number,
      softwareSetupId: number
    ) {
      return updateSoftwarePayment({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: ItManagementApplicationDetailsPageQueryDocument,
            variables: {
              currency: currency,
              companyId: companyId,
              softwareSetupId: softwareSetupId,
            },
          },
        ],
      })
    },
    loading,
  }
}
